import React, { useContext } from 'react'
import { t } from '@lingui/macro'
import { cx } from '@emotion/css'
import { AnalyticsContext } from '../../../pages/analytics/AnalyticsContext'
import { AnalyticsFiltersEnum } from '../../../pages/analytics/constants'
import { LinkBox } from 'front-end/src/components'

type ChangeIncludedResourcesCheckboxesProps = {
  activeFilters?: Array<AnalyticsFiltersEnum>
}

export const ChangeIncludedEntitiesCheckboxes: React.FC<ChangeIncludedResourcesCheckboxesProps> =
  ({ activeFilters }) => {
    const { filter, changeFilter } = useContext(AnalyticsContext)

    const isFilterActive = (filter: AnalyticsFiltersEnum) =>
      activeFilters?.includes(filter)

    const FILTERS_CONDITIONS: Record<string, [AnalyticsFiltersEnum, string]> = {
      includeAdmins: [AnalyticsFiltersEnum.INCLUDE_ADMINS, t`Include admins`],
      includeArchived: [
        AnalyticsFiltersEnum.INCLUDE_ARCHIVED,
        t`Include archived`
      ],
      includeDrafts: [AnalyticsFiltersEnum.INCLUDE_DRAFTS, t`Include drafts`]
    }

    const filtersToRender = Object.entries(FILTERS_CONDITIONS)
      .map(([filterKey, [filterId, text]]) => {
        if (isFilterActive(filterId)) {
          return (
            <LinkBox
              key={filterKey}
              className={cx('AnalyticsFilter__checkbox', {
                'AnalyticsFilter__checkbox--active': filter[filterKey]
              })}
              onClick={() => {
                changeFilter({ [filterKey]: !filter[filterKey] })
              }}
            >
              {text}
            </LinkBox>
          )
        }
      })
      .filter(Boolean)

    if (!filtersToRender.length) {
      return null
    }

    return (
      <div className="AnalyticsFilter__checkboxes">
        {filtersToRender.map((v) => v)}
      </div>
    )
  }
